import * as http from "../services/http";
import { userRoutes, agentRouts, clientRouts, shippingClientRouts } from "../routes/RouteList";
import { KeyValue } from "../models/Core/key-value";

class Status {
    token: string = "";
    options:any= {
        NumbersAfterDecimal: 2,
        RoundType: 2,
        CurrList: []
    };
    perms: any[] = [];
    routs: any[] =[];
    userType = -1;
    LangKey: KeyValue[] = [];
    Branches: KeyValue[] = [];
    UserBranches: KeyValue[] = [];
    AgentsCountries: KeyValue[] = [];
    BanksCountries: KeyValue[] = [];
    AgentCities: KeyValue[] = [];
    Cities: KeyValue[] = [];
    AllCities: KeyValue[] = [];
    Agents: KeyValue[] = [];
    AgentCurrencies: KeyValue[] = [];
    Currencies: KeyValue[] = [];
    Nationalities: KeyValue[] =[];
    IdentityKind: KeyValue[] =[];
    permissions: KeyValue[] = [];
    LicenseKinds: KeyValue[] = [];
    layoutVal= 0;
    AgentCur: KeyValue[] = [];
    branchCurrencies: KeyValue[] = [];
    Tellers: KeyValue[] = [];
    AllUserTellers: KeyValue[] =[];
    Countries: KeyValue[] = [];
    BranchTellers: KeyValue[] =[];
    CurrentBranchCurr: KeyValue[] =[];
    AllBranchesCurrencies: KeyValue[] = [];
    Banks: KeyValue[] = [];
    RemBanks: KeyValue[] =[];
    RoundOption: any = null;
    IsCentralBank: boolean | null= null;
    UserTellers: KeyValue[] = [];
    Warehouses: KeyValue[] = [];
    Companies: KeyValue[] = [];
    TranCompanies: KeyValue[] = [];
    Containers: KeyValue[] =[];
    ExchReasons: KeyValue[] =[];
    RemReasons: KeyValue[] =[];
    AllUsers: KeyValue[] =[];
    ResourcesLang: KeyValue[] = [];
    AgentsAccounts: KeyValue[] = [];
    CostCenters: KeyValue[] =[];
    BankBranches: KeyValue[] = [];
    Accounts: KeyValue[] = [];
    Jobs: KeyValue[] = [];
    AllCurrencies: KeyValue[] =[];
    AgentBranches: KeyValue[] =[];
    AgentBalance: any = { list: [], balanceAccount: "0" };
};
var Loading: string[] = [];

export const getData = (dataName: string, headerObj?: any, cb?: (data: KeyValue[]) => void) => async (dispatch: (obj: any) => void, getState: () => any) => {
    if (Loading.includes(dataName)) 
        await new Promise(r => setTimeout(r, 2000));
    const data = getState().data[dataName];
    if (data && data.length > 0) {
        if (cb)
            cb(data);
        return;
    }
    Loading.push(dataName)
    http.get('/Service/Get' + dataName, headerObj, (data) => {
        Loading = Loading.filter(r => r !== dataName)
        dispatch({
            type: "ADD_DATA",
            dataName,
            payload: data.AdditionalData
        });
        setTimeout(() => { if (cb) cb(data.AdditionalData) }, 0);
    });
};

function getAvailableRouts(perms: any[], options: any) {
    var InterfaceRoutes:any = +options.InterfaceType === 0 ? agentRouts : +options.InterfaceType === 4 ?
        clientRouts : +options.InterfaceType === 5 ? shippingClientRouts : userRoutes;
    return InterfaceRoutes.filter((item: any) => {
        return (item.perm !== 31 || options.UserID === 1) &&//عدم اظهار الحسابات المجمدة غير لليوزر الادمن
            ((item.perm === 0 && !item.perms) ||//اظهار النوافذ التي لاتحتاج صلاحيات
                perms.find(row => { return (+row.PermName === +item.perm || (+row.PermName === 7202 && +item.perm === 7200)) && +row[item.permKind ? item.permKind : "Read"] === 1 }) ||//اظهار النوافذ التي يملك المستخدم صلاحية عليها
                (item.perms && perms.find(row => {//من اجل النوافذ المساعدة او اي نافذة ممكن تفتح باكثر من صلاحية
                    return item.perms.split(',').includes(row.PermName + '') && +row[item.permKind ? item.permKind : "Read"] === 1
                }))
            ) && (item.perm !== 7202 || options.IsExternalRemitt);
    });
};
interface DataAction {
    type: string;
    dataName: string;
    payload: any;
}
export default function appDataReducer(appData = new Status(), action: DataAction) {

    switch (action.type) {
        case "ADD_DATA":
            let returnObj: any = { ...appData };
            returnObj[action.dataName] = action.payload;
            return returnObj;
        case "LOGIN":
            var loginRouts = getAvailableRouts(action.payload.Perms, action.payload.Options);
            return {
                ...appData,
                options: action.payload.Options,
                perms: action.payload.Perms,
                routs: loginRouts
            };
        case "RELOAD":
            var perms = action.payload.IsLoged ? action.payload.User.Perms : [];
            var routs = getAvailableRouts(perms, action.payload.IsLoged ? action.payload.User.Options : action.payload.Options);
            let LangKey = localStorage.getItem("LangKey");
            if (action.payload.keyValues.length > 0)
                localStorage.setItem("LangKey", JSON.stringify(action.payload.keyValues));
            return {
                ...appData,
                LangKey: LangKey === null ? action.payload.keyValues : JSON.parse(LangKey),
                options: action.payload.IsLoged ? action.payload.User.Options : action.payload.Options,
                perms,
                routs
            };
        default:
            return appData
    }
}